import React from 'react';

/**
 * Returns a debounced copy of `value` that only updates after `delay` ms have
 * elapsed without a change. Useful for throttling search inputs that feed a
 * server query so each keystroke doesn't fire a request.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = React.useState(value);

  React.useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handle);
  }, [value, delay]);

  return debounced;
}
